// Provider registry — the one place that knows the concrete providers. Swapping
// the configured provider (AC5) is a lookup here; no consumer changes.

import type { ProviderId } from '@/lib/keys/types'
import type { TranscriptionProvider } from '../types'
import { createSonioxProvider } from './soniox'
import { createSpeechmaticsProvider } from './speechmatics'

export interface ProviderConfig {
  /** Soniox only: use the user's own key on the socket (no temp-key mint). */
  sonioxDirectKey?: boolean
}

export function getProvider(
  id: ProviderId,
  cfg: ProviderConfig = {}
): TranscriptionProvider {
  switch (id) {
    case 'soniox':
      return createSonioxProvider({ directKey: cfg.sonioxDirectKey })
    case 'speechmatics':
    default:
      return createSpeechmaticsProvider()
  }
}
